import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import AnalysisGate from './ContentTab/AnalysisGate';
import AiReadyReportList from './ContentTab/AiReadyReportList';

const Pane = styled.div`
  flex: 1;
  overflow-y: auto;
`;

// The AI-ready reports that reach one domain. "+ Add test" on a report (or a
// metric line within it) opens the domain's tests panel prefilled — the metric
// line pre-selects that metric as the expected one.

const DomainReportsPanel = () => {
  const { domainId } = useParams<{ domainId: string }>();
  const navigate = useNavigate();
  const domain = decodeURIComponent(domainId ?? '');

  return (
    <Pane data-testid="agent-domain-reports">
      <AnalysisGate>
        <AiReadyReportList
          domain={domain}
          onAddTest={({ report, metricId }) =>
            navigate('../tests', {
              state: {
                prefillTest: {
                  question: '',
                  metricId,
                  reportId: report.reportId,
                  reportMetricIds: report.metricIds,
                },
              },
            })
          }
        />
      </AnalysisGate>
    </Pane>
  );
};

export default DomainReportsPanel;
